#import "../../../../../core/graphql/fragments/custom-field-edge-fragment.graphql"

query GetWidgetCustomFields($entityId: ID!, $widgetId: ID!) {
    widgetCustomFields(entityId: $entityId, widgetId: $widgetId) {
        edges {
            ...CustomFieldEdgeFragment
        }
    }
}
